
import {NgModule} from "@angular/core";
import {HighlightsComponent} from "./highlights.component";
import {HighlightComponent} from "../highlight/highlight.component";
import {HighlightService} from "../services/highlight.service";
import {CommonModule} from "@angular/common";
import {RouterModule} from "@angular/router";

@NgModule({
  imports: [CommonModule, RouterModule],
  providers: [HighlightService],
  declarations: [HighlightsComponent, HighlightComponent],
  exports: [HighlightsComponent, HighlightComponent]
})
export class HighlightsModule {}
